var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifierIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.86 85.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #5e7db8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.93,48.18c-13.03,0-23.63-10.6-23.63-23.63S29.9.75,42.93.75s23.63,10.77,23.63,23.8-10.6,23.63-23.63,23.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.43,
    y: 58.86,
    width: 21,
    height: 26.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.93,
    y: 58.86,
    width: 21.17,
    height: 26.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.75,
    y: 58.86,
    width: 21.17,
    height: 26.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.75,
    y1: 69.36,
    x2: 21.92,
    y2: 69.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.43,
    y1: 69.36,
    x2: 53.43,
    y2: 69.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.93,
    y1: 69.36,
    x2: 85.11,
    y2: 69.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.93,
    y1: 48.18,
    x2: 42.93,
    y2: 58.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.43 58.86 11.43 42.93 28.09 42.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "57.76 42.93 74.43 42.93 74.43 58.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.06,77.23c0,1.45-1.17,2.63-2.62,2.63s-2.63-1.18-2.63-2.63,1.18-2.62,2.63-2.62,2.62,1.18,2.62,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.55,77.23c0,1.45-1.17,2.63-2.63,2.63s-2.62-1.18-2.62-2.63,1.17-2.62,2.62-2.62,2.63,1.18,2.63,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.05,77.23c0,1.45-1.18,2.63-2.63,2.63s-2.62-1.18-2.62-2.63,1.17-2.62,2.62-2.62,2.63,1.18,2.63,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.77,38.65c-.06-1.44-.95-2.71-2.29-3.27-.47-.19-.96-.29-1.46-.29-.94,0-1.83.34-2.53.96l-3.05-3.05c.98-1.07,1.25-2.6.68-3.95-.57-1.35-1.84-2.25-3.29-2.34v-4.31c1.44-.06,2.71-.95,3.27-2.29.56-1.36.3-2.9-.66-4l3.05-3.05c.69.63,1.57.97,2.51.97.49,0,.98-.1,1.44-.29,1.35-.57,2.25-1.84,2.34-3.29h4.31c.06,1.44.95,2.71,2.29,3.27.47.19.96.29,1.46.29.94,0,1.83-.34,2.53-.96l3.05,3.05c-.98,1.07-1.25,2.6-.68,3.95.57,1.35,1.84,2.25,3.29,2.34v4.31c-1.44.06-2.71.95-3.27,2.29-.56,1.36-.3,2.9.66,4l-3.05,3.05c-.69-.63-1.57-.97-2.51-.97-.5,0-.98.1-1.44.29-1.35.57-2.25,1.84-2.34,3.29h-4.31Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.93,
    y1: 24.46,
    x2: 42.93,
    y2: 32.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.42 28.66 42.93 31.91 36.43 28.66 36.43 20.55 42.93 17.3 49.42 20.55 49.42 28.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "49.42 20.55 42.93 23.8 36.43 20.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifierIcon3);
export default __webpack_public_path__ + "static/media/verifier-icon-3.0848f67d87683c2baf4a457d21a97e57.svg";
export { ForwardRef as ReactComponent };